module.exports = __webpack_public_path__ + "static/media/movein@3x.c2c16b1f.png";